export function removeCommasFromString(inputString: string): string {
  return inputString.replace(/,/g, '')
}
